import React from 'react'
import EditProfile from './account/EditProfile'

function Settings() {
    return (
        <div>
            <EditProfile />
        </div>
    )
}

export default Settings
